/**
 * TagListPresenter
 * --
 */
import { useState, useReducer } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  Table,
  ModalLayout,
} from 'components';
import { Button, Form, Input, List, Checkbox, Tag, Modal } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { TagApi } from 'api';
import MessageAlert from 'utils';
import moment from 'moment';
import { useQueryClient } from '@tanstack/react-query';
import { TagRegisterContent } from './components';
import styled from 'styled-components';
import { styles } from './styles'

/**
 * TODO JM 피그마 요청 사항
 * --
 * 1. 검색엔진 서비스 연결
 */

const TagListPresenter = ({ tagList }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [selectedTag, setSelectedTag] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [state, dispatch] = useReducer(
      (state, action) => {
        switch (action.type) {
          case 'CHANGE_TAG_NAME':
            return {
              ...state,
              tag_name: action.value
            };
          case 'CHANGE_IS_SHOW':
            console.log(action.value);
            return {
              ...state,
              is_show: action.value
            }
          case 'CLEAR':
            return {
              tag_id: null,
              tag_name: '',
              is_show: true
            }
          case 'INITIALIZE':
            return {
              ...action.value
            }
          default:
            throw new Error(`${action.type}을 찾을 수 없습니다.`);
        }
      },
      { tag_id: null, tag_name: '', is_show: true }
    );

  /* ===== VARIABLE ===== */
  const queryClient = useQueryClient();

  

  const handleClickCreateTag = () => {
    setIsOpen(true);
  }

  const handleClose = () => {
    setIsOpen(false);
    dispatch({ type: 'CLEAR' });
  }

  const handleSave = async () => {
    const isAlreadyTagName = tagList.some((tag) => tag.tag_name === state.tag_name);

    if (state.tag_id === null && isAlreadyTagName) {
      MessageAlert.warning('이미 등록된 태그입니다.');
      return;
    }

    const api = state.tag_id === null ? TagApi.createTag : TagApi.updateTag;
    const response = await api({
      ...state,
      is_show: state.is_show ? 'Y' : 'N'
    });

    if (response.status === 200) {
      const message = state.tag_id === null ? '태그를 등록하였습니다.' : '태그를 수정하였습니다.';
      MessageAlert.success(message);
      
      setTimeout(() => {
        queryClient.resetQueries({ queryKey: ['tag'] }); 
        handleClose();
      }, 100)
    } else {
      MessageAlert.error('태그 등록을 실패하였습니다.');
    }
  }

  const handleDeleteTag = (tag) => {
    Modal.confirm({
      title: '정말 이 태그를 삭제하시겠습니까?',
      content: `삭제 태그 : ${tag.tag_name}`,
      okText: '삭제',
      onOk: async () => {
        if (tag.tag_id) {
          const response = await TagApi.deleteTag(tag.tag_id);

          if (response && response.status === 200) {
            MessageAlert.success('태그를 삭제하였습니다.')
            queryClient.resetQueries({ queryKey: ['tag'] }); 
          } else {
            MessageAlert.error('태그 삭제 중 오류가 발생하였습니다.');
          }
        }
      },
      cancelText: '취소',
      onCancel() {},
    })
  }

  const handleUpdateTag = (tag) => {
    setIsOpen(true);
    dispatch({ 
      type: 'INITIALIZE', 
      value: {
        tag_id: tag.tag_id,
        tag_name: tag.tag_name, 
        is_show: tag.is_show === 'Y' ? true : false 
    }})
  }

  const handleClickTag = (tag) => {
    if (tag) {
      setSelectedTag(tag);
    }
  }

  const getProduct = () => {
    if (selectedTag && Array.isArray(selectedTag.products)) {
      return selectedTag.products;
    }

    return [];
  }
  

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>태그 목록</Title>

          {/* 태그 생성 */}
          <TagRegisterContent tagList={tagList} />

          {/* 검색결과 */}
          <Row gutter={[10, 10]}>
            <Col x={6}>
              <Content
                maxWidth={'100%'}
                borderRadius={4}
                padding={20}
                style={{ height: '100%' }}
              >
                <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
                  검색 결과 총 <span>{tagList.length}</span>건
                </h4>
                <List
                  itemLayout="horizontal"
                  dataSource={tagList}
                  renderItem={(item) => (
                    <ListItem 
                      key={item.tag_id} 
                      isActive={(selectedTag && selectedTag.tag_id === item.tag_id) ? true : false}
                      onClick={() => handleClickTag(item)}
                    >
                      <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <div>
                          <div>
                            {item.tag_name}
                          </div>
                          <div style={{ fontSize: '12px', color: 'gray' }}>                            
                            {item.is_show === 'Y' ? (
                              <Tag color="success">노출</Tag>
                            ) : (
                              <Tag color="default">미노출</Tag>
                            )}
                            &nbsp;
                            {moment.unix(item.updated_at).format('YYYY-MM-DD')}
                          </div>
                        </div>
                        <div>
                          <Button 
                            size='small' 
                            icon={<EditOutlined />}
                            onClick={() => handleUpdateTag(item)}
                          />
                          &nbsp;
                          &nbsp;
                          <Button 
                            size='small' 
                            icon={<DeleteOutlined />} 
                            danger 
                            onClick={() => handleDeleteTag(item)}
                          />
                        </div>
                      </div>
                    </ListItem>
                  )}
                />
              </Content>
            </Col>
            <Col x={18}>
              <Content
                maxWidth={'100%'}
                borderRadius={4}
                padding={20}
                style={{ height: '100%' }}
              >
                <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
                  검색 결과 총 <span>{getProduct().length}</span>건
                </h4>
                <Table
                  data={getProduct()}
                  columns={[
                    {
                      title: '상품코드',
                      key: 'product_code',
                    },
                    {
                      title: '상품명',
                      key: 'product_name',
                      render: (item) => (
                        <button
                          style={{
                            border: 'none',
                            background: 'none',
                            textDecoration: 'underline',
                            color: '#1C6BFF',
                            cursor: 'pointer',
                          }}
                        >
                          {item}
                        </button>
                      ),
                    },
                    {
                      title: '비고',
                      key: '비고',
                      render: () => (
                        <>
                          <Button
                            size="small"
                            style={{
                              borderColor: 'var(--primary-color)',
                              color: 'var(--primary-color)',
                              marginRight: 4,
                            }}
                          >
                            수정
                          </Button>
                          <Button
                            size="small"
                            style={{ borderColor: '#EE4700', color: '#EE4700' }}
                          >
                            삭제
                          </Button>
                        </>
                      ),
                    },
                  ]}
                />
              </Content>
            </Col>
          </Row>
          {/* 검색결과 끝 */}
        </Col>
      </Row>
      
    </Content>
  );
};

const ListItem = styled(List.Item)`
  cursor: pointer; 
  border: 1px solid #d8d8d8 !important;
  border-radius: 10px; 
  padding: 20px 10px !important;
  margin-bottom: 5px;

  &:hover {
    background-color: #e5f2ff;
  }

  background-color: ${({ isActive }) => isActive ? '#e5f2ff' : 'none'};
`

export default TagListPresenter;
